import { EditableText, EditableTitle } from "@/components/EditableText";
import { Column } from "@/components/ui/flex";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

type DisplayEditorProps = {
  name: string;
  description: string | null;
  onNameChange: (name: string) => Promise<unknown>;
  onDescriptionChange: (description: string) => Promise<unknown>;
};

function withErrorHandling<T, E>(
  fn: (arg: T) => Promise<E>,
  name: string = "",
  errorMessage: string = "An error occurred while updating the display settings.",
) {
  return async (arg: T) => {
    try {
      await fn(arg);
      toast.success(`${name || "Item"} updated successful!`);
    } catch (error) {
      console.error("Error:", error);
      toast.error(errorMessage);
    }
  };
}

export default function DisplayEditor({
  name,
  description,
  onNameChange,
  onDescriptionChange,
}: DisplayEditorProps) {
  return (
    <Column className="gap-8">
      <Column className="gap-4">
        <Label>Name</Label>
        <EditableTitle
          value={name}
          onUpdate={withErrorHandling(onNameChange, "Name")}
          placeholder="Name"
          className="text-xl"
        />
      </Column>

      <Column className="gap-4">
        <Label>Description</Label>
        <EditableText
          value={description ?? ""}
          placeholder="Write a description..."
          onUpdate={withErrorHandling(onDescriptionChange, "Description")}
        />
      </Column>
    </Column>
  );
}
